import { FC, lazy } from 'react';
import { useParams } from 'react-router-dom';
import { useFutureShipperUser } from 'src/pages/shipper-admin/details/use-future-shipper-user';
import { useShipper } from 'src/pages/shipper-admin/details/use-shipper';

const Page = lazy(() => import('./page'));

export const EditShipperUserDetails: FC = () => {
  const { oldUserId } = useParams<{ oldUserId: string }>();
  const futureShipperUser = useFutureShipperUser(oldUserId!);
  const shipper = useShipper();
  return <Page shipper={shipper} futureShipperUser={futureShipperUser} />;
};
